import React from 'react';
import SectionContainer from '../../common/SectionContainer';
import FieldRow from '../../common/FieldRow';

// En 14 D N°8 la empresa no paga primera categoría y sus PPM no se imputan en su F22
const LiquidacionSection = ({ computed }) => (
  <SectionContainer title="Impuesto a pagar" subtitle="Liquidación anual: la empresa queda liberada del IDPC">
    <div className="f22-subsection">
      <FieldRow label="Base imponible asignable a los propietarios" code="1712" value={computed.r23?.baseImponible} computed className="f22-field-subtotal" />
      <FieldRow label="PPM puestos a disposición de los propietarios (DJ 1947, columna C14)" value={computed.liquidacion?.ppmPuestosADisposicion} computed />
      <FieldRow label="RESULTADO LIQUIDACIÓN ANUAL IMPUESTO A LA RENTA" code="305" sign="(=)" value={computed.liquidacion?.resultado305} computed className="f22-field-final-result" />
      <p className="f22-hint">
        Los PPM de la empresa no se imputan en su F22: van a los propietarios en la DJ 1947 y cada uno los rebaja de su
        Impuesto Global Complementario en su propio F22 (código 1645). Una pérdida tributaria no se asigna: se deduce como
        egreso del año siguiente (Circular SII N° 62 de 2020, apartado 2.4.1).
      </p>
    </div>
  </SectionContainer>
);

export default LiquidacionSection;
